import React from 'react';
import { Card, Row, Col, Container } from 'react-bootstrap';
import { useLocation, useParams } from 'react-router-dom';
import { GetPublic } from '@app/utils/httpProvider';
import { useQuery } from 'react-query';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Table } from 'react-bootstrap';
import 'react-tabs/style/react-tabs.css';
import {
    ASSET_API, BaseGatewayImage
} from '../../utils/apiUrl.js';
import { isValidUrl } from '../../utils/helper.js';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';

const AssetPublicDetail = () => {
    const { id } = useParams();
    const location = useLocation();
    
    // Fallback to query param if not in URL segment
    const paramUrl = new URLSearchParams(location.search.substring(1));
    const itemId = id || paramUrl.get('id');

    const itemQuery = useQuery(['publicAsset', itemId], () =>
        GetPublic(ASSET_API.GET_PUBLIC_ITEM, itemId)
    );

    const isLoading = itemQuery.isLoading;
    const isError = itemQuery.isError;
    const error = itemQuery.error;
    const asset = itemQuery.data;

    const getAccessoryStatusStyle = (status) => {
        switch (status) {
            case 'Hoạt động': return { bg: 'rgba(40,167,69,0.12)', border: 'rgba(40,167,69,0.5)', text: '#28a745' };
            case 'Không hoạt động': return { bg: 'rgba(108,117,125,0.12)', border: 'rgba(108,117,125,0.5)', text: '#6c757d' };
            case 'Hỏng': return { bg: 'rgba(220,53,69,0.12)', border: 'rgba(220,53,69,0.5)', text: '#dc3545' };
            default: return { bg: 'rgba(108,117,125,0.1)', border: 'rgba(108,117,125,0.4)', text: '#6c757d' };
        }
    };

    if (isLoading) return <Container className="mt-5 text-center"><h5>Đang tải thông tin tài sản...</h5></Container>;
    if (isError) return <Container className="mt-5 text-center text-danger"><h5>Có lỗi xảy ra: {error.message}</h5></Container>;
    if (!asset) return <Container className="mt-5 text-center"><h5>Không tìm thấy thông tin tài sản</h5></Container>;

    const renderField = (label, value) => (
        <div className="d-flex flex-column flex-sm-row border-bottom py-2">
            <div className="text-left mb-1 mb-sm-0" style={{ fontWeight: 600, color: '#495057', minWidth: '150px' }}>{label}:</div>
            <div className="text-dark flex-grow-1" style={{ wordBreak: 'break-word' }}>{value || '---'}</div>
        </div>
    );

    return (
        <Container fluid="sm" className="px-1 px-sm-3 mt-2 mt-sm-4 mb-4">
            <Card className="shadow-sm border-0">
                <Card.Header className="bg-primary text-white text-center py-3">
                    <h4 className="mb-0">CHI TIẾT TÀI SẢN</h4>
                </Card.Header>
                <Card.Body>
                    <Tabs>
                        <TabList className="react-tabs__tab-list d-flex flex-nowrap overflow-auto" style={{ whiteSpace: 'nowrap', WebkitOverflowScrolling: 'touch', margin: 0, padding: 0, borderBottom: '1px solid #aaa' }}>
                            <Tab className="react-tabs__tab" style={{ flex: '0 0 auto' }}>Thông tin chung</Tab>
                            <Tab className="react-tabs__tab" style={{ flex: '0 0 auto' }}>Hình ảnh & Tài liệu</Tab>
                            <Tab className="react-tabs__tab" style={{ flex: '0 0 auto' }}>Danh sách phụ kiện</Tab>
                        </TabList>

                        <TabPanel>
                            <div className="mt-3 px-2 px-sm-0">
                                <h6 className="text-primary pb-2 mb-2 font-weight-bold" style={{ borderBottom: '2px solid #007bff' }}>Thông tin định danh</h6>
                                <Row>
                                    <Col md={6}>
                                        {renderField('Mã tài sản', asset.assetCode)}
                                        {renderField('Tên tài sản', asset.assetName)}
                                        {renderField('Số thẻ tài sản', asset.cardNumber)}
                                        {renderField('Ngày tạo thẻ', asset.cardCreatedDate ? moment(asset.cardCreatedDate).format('DD/MM/YYYY') : '')}
                                    </Col>
                                    <Col md={6}>
                                        {renderField('Nhóm tài sản', asset.assetGroupName)}
                                        {renderField('Phòng ban', asset.departmentName)}
                                        {renderField('Trạng thái', asset.assetStatusName)}
                                        {renderField('Thanh lý', asset.isDisposed ? 'Đã thanh lý' : 'Chưa thanh lý')}
                                    </Col>
                                </Row>

                                <h6 className="text-primary pb-2 mt-4 mb-2 font-weight-bold" style={{ borderBottom: '2px solid #007bff' }}>Thông số kỹ thuật</h6>
                                <Row>
                                    <Col md={6}>
                                        {renderField('Số Serial', asset.serialNumber)}
                                        {renderField('Model / Ký hiệu', asset.model)}
                                        {renderField('Nhà sản xuất', asset.manufacturer)}
                                    </Col>
                                    <Col md={6}>
                                        {renderField('Xuất xứ', asset.country)}
                                        {renderField('Công suất', asset.powerSpec)}
                                    </Col>
                                </Row>

                                <h6 className="text-primary pb-2 mt-4 mb-2 font-weight-bold" style={{ borderBottom: '2px solid #007bff' }}>Thông tin mua sắm</h6>
                                <Row>
                                    <Col md={6}>
                                        {renderField('Ngày mua', asset.purchaseDate ? moment(asset.purchaseDate).format('DD/MM/YYYY') : '')}
                                    </Col>
                                    <Col md={6}>
                                        {renderField('Giá trị mua', asset.purchaseValue ? asset.purchaseValue.toLocaleString('vi-VN') + ' VND' : '')}
                                    </Col>
                                </Row>
                            </div>
                        </TabPanel>

                        <TabPanel>
                            <div className="mt-3 px-2 px-sm-0">
                                <h6 className="text-primary pb-2 mb-3 font-weight-bold" style={{ borderBottom: '2px solid #007bff' }}>Ảnh tài sản</h6>
                                <div className="text-center mb-4">
                                    {asset.imagePath ? (
                                        <img 
                                            src={isValidUrl(asset.imagePath) ? asset.imagePath : BaseGatewayImage + asset.imagePath} 
                                            alt={asset.assetName} 
                                            className="img-fluid rounded shadow-sm" 
                                            style={{ maxHeight: '400px', objectFit: 'contain', width: '100%' }} 
                                        />
                                    ) : (
                                        <div className="p-4 p-sm-5 bg-light border rounded text-muted">Không có ảnh tài sản</div>
                                    )}
                                </div>

                                <h6 className="text-primary pb-2 mt-4 mb-3 font-weight-bold" style={{ borderBottom: '2px solid #007bff' }}>Tài liệu kèm theo</h6>
                                <ul className="list-group list-group-flush border rounded shadow-sm">
                                    {asset.documentLink && asset.documentLink.length > 0 ? (
                                        asset.documentLink.map((link, index) => (
                                            <li key={index} className="list-group-item d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
                                                <span className="mb-2 mb-sm-0 font-weight-bold"><i className="fas fa-file-alt text-secondary mr-2"></i>Tài liệu {index + 1}</span>
                                                <a href={isValidUrl(link) ? link : BaseGatewayImage + (link.startsWith('/') ? '' : '/') + link} download target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-success shadow-none w-100 w-sm-auto text-center">
                                                    <i className="fas fa-download mr-1" /> Tải xuống
                                                </a>
                                            </li>
                                        ))
                                    ) : (
                                        <li className="list-group-item text-muted text-center py-3">Không có tài liệu đính kèm</li>
                                    )}
                                </ul>
                            </div>
                        </TabPanel>

                        <TabPanel>
                            <div className="mt-3 px-2 px-sm-0">
                                <h6 className="text-primary pb-2 mb-3 font-weight-bold" style={{ borderBottom: '2px solid #007bff' }}>Danh sách phụ kiện</h6>
                                <div className="table-responsive shadow-sm rounded border">
                                    <Table striped bordered hover size="sm" className="mb-0 text-nowrap">
                                        <thead>
                                            <tr className="text-dark fw-bold text-uppercase" style={{ fontSize: '12px', background: '#e9ecef' }}>
                                                <th className="text-center py-2" style={{ width: '50px' }}>STT</th>
                                                <th className="py-2">Mã phụ kiện</th>
                                                <th className="py-2">Tên phụ kiện</th>
                                                <th className="py-2">Quy cách</th>
                                                <th className="py-2">Đơn vị</th>
                                                <th className="text-center py-2">Số lượng</th>
                                                <th className="text-center py-2">Trạng thái</th>
                                                <th className="py-2">Ghi chú</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(!asset.accessories || asset.accessories.length === 0) && (
                                                <tr>
                                                    <td colSpan="8" className="text-center text-muted py-4">
                                                        <i className="fas fa-box-open mr-2 mb-2 d-block" style={{ fontSize: '24px', color: '#ccc' }}></i>
                                                        Không có phụ kiện kèm theo
                                                    </td>
                                                </tr>
                                            )}
                                            {asset.accessories && asset.accessories.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td className="text-center align-middle">{index + 1}</td>
                                                    <td className="align-middle">{item.materialCode}</td>
                                                    <td className="align-middle" style={{ whiteSpace: 'normal', minWidth: '150px' }}>{item.materialName}</td>
                                                    <td className="align-middle" style={{ whiteSpace: 'normal', minWidth: '120px' }}>{item.specification}</td>
                                                    <td className="align-middle">{item.unit}</td>
                                                    <td className="text-center align-middle font-weight-bold">{item.quantity}</td>
                                                    <td className="text-center align-middle">
                                                        {(() => {
                                                            const s = getAccessoryStatusStyle(item.accessoryStatus);
                                                            return (
                                                                <span style={{
                                                                    display: 'inline-block',
                                                                    padding: '4px 12px',
                                                                    borderRadius: '999px',
                                                                    fontSize: '11px',
                                                                    fontWeight: 700,
                                                                    background: s.bg,
                                                                    color: s.text,
                                                                    border: `1px solid ${s.border}`,
                                                                    whiteSpace: 'nowrap',
                                                                }}>
                                                                    {item.accessoryStatus}
                                                                </span>
                                                            );
                                                        })()}
                                                    </td>
                                                    <td className="align-middle" style={{ whiteSpace: 'normal', minWidth: '150px' }}>{item.note}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </TabPanel>
                    </Tabs>
                </Card.Body>
                <Card.Footer className="text-center text-muted small">
                    Hệ thống Quản lý Trang thiết bị - {new Date().getFullYear()}
                </Card.Footer>
            </Card>
        </Container>
    );
};

export default AssetPublicDetail;
